<template>
  <div v-if="vista==='calcularExtracto'" style="margin: 0 -3vw;">
    <div class="flex flex-wrap justify-center gap-y-3 md:gap-0 sm:justify-between w-full px-4 py-2 items-center">
      <div class="text-xl font-bold w-full sm:w-auto text-center">Informe Rendimientos Extracto - {{
          informacionCalculoMovimientos.tipo_cuenta === 'ahorro' ? 'Cuenta de Ahorros'
              : informacionCalculoMovimientos.tipo_cuenta === 'corriente' ? 'Cuenta Corriente' : 'Cuenta de Nómina'
        }} {{ informacionCalculoMovimientos.cuenta_bancaria }} -
        {{ firstLetterCapitalize(informacionCalculoMovimientos.nombre_banco) }}
      </div>
      <button @click="emit('updateValues', {'view':'listar'}); temporalAddings = []; addingYear = undefined; addingMonth = undefined; addingValue = undefined"
              class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <template v-for="(infoYear, year, index) in resultCalculation" :key="index">
      <template v-for="(infoMes, mes, index) in infoYear" :key="'A'+index">
        <!-- MES Y AÑO-->
        <template v-for="(row, indexRow) of infoMes" :key="'B'+indexRow">
          <template v-if="indexRow===1">
            <template v-for="(col, index) of row" :key="'C'+index">
              <template v-if="index===2">
                <h1 class="text-black font-bold text-2xl mb-4 text-center">{{ col['value'] }}</h1>
              </template>
            </template>
          </template>
        </template>
        <!-- ENCABEZADOS-->
        <div class="shadow-2xl p-5">
          <div v-if="informacionCalculoMovimientos['manejo_cuenta']" class="mb-20 ml-20">
            <span class="text-black font-bold text-2xl">CONDICIONES DE MANEJO: </span><span class="text-2xl font-light">{{ informacionCalculoMovimientos['manejo_cuenta'] }}</span>
          </div>
          <div class="flex justify-center">
            <div class="text-center p-6 bg-gray-300 border border-black w-1/6">
              <h1 class="font-medium">TASA REPRESENTATIVA</h1>
            </div>
            <div class="text-center p-6 bg-gray-100 border border-black w-1/6">
              <h1>{{informacionCalculoMovimientos[selectedYear][selectedMonth]['tasa_representativa']}}%</h1>
            </div>
          </div>
          <div class="calculate-container-headers w-full">
            <template v-for="(row, indexRow) of infoMes" :key="'D'+indexRow">
              <template v-if="indexRow>=1&&indexRow<=3||indexRow>=infoMes.length-7">
                <template v-for="(col, index) of row" :key="'E'+index">
                  <template v-if="indexRow===1">
                    <h1 :class="'text-black font-bold text-2xl mb-4 text-center '+`calculate-header-item-main${index}`"
                        v-if="index===0">RENDIMIENTOS REALES</h1>
                    <h1 :class="'text-black font-bold text-2xl mb-4 text-center '+`calculate-header-item-main${index}`"
                        v-if="index===6">RENDIMIENTOS PACTADOS</h1>
                  </template>
                  <div v-else-if="col&&col['value']&&indexRow>=2"
                       :class="'font-medium text-black '+(
                      indexRow===2?`calculate-header-item-a${index}`:
                      (indexRow===3?`calculate-header-item-b${index}`:(indexRow===infoMes.length-7?`calculate-header-item-c${index}`:
                      (indexRow===infoMes.length-6?`calculate-header-item-d${index}`:(indexRow===infoMes.length-5?`calculate-header-item-e${index}`:
                      (indexRow===infoMes.length-4?`calculate-header-item-f${index}`:(indexRow===infoMes.length-3?`calculate-header-item-g${index}`:
                      (indexRow===infoMes.length-2?`calculate-header-item-h${index}`:`calculate-header-item-i${index}`
                      ))))))))+' '+(col['classText']?col['classText']:'')+' '+(isNaN(col['value'].replaceAll(',','').replaceAll('%',''))?'bg-gray-300':'bg-gray-100')"
                       :style="'word-wrap: break-word;border: 1px solid black;display:flex;align-items:center; '+(col['isInput']?'':'padding-left:10px;')">
                    <input v-if="col['isInput']" @keyup="updateValues($event, year, mes)" :id="col['idInput']"
                           type="text" class="width-fill-available height-fill-available"
                           style="border: 5px solid red;margin: 1px;"/>
                    <template v-else>{{ col['value'] }}</template>
                  </div>
                  <button v-else-if="indexRow===2&&index===2"
                          class="calculate-header-calculate-tasaea text-white bg-green-500 w-full p-2 w-full hover:bg-green-600 focus:outline-none"
                          @click="calculateEA(year, mes)">
                    <span class="me-3">Calcular Tasa E.A.</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="inline-block w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"/>
                    </svg>
                  </button>
                </template>
              </template>
            </template>
          </div>
          <div class="mt-10">
            <h1 class="text-black font-bold text-2xl text-center w-1/4">ABONOS:</h1>
            <div class="flex flex-row space-x-5 my-10">
              <label for="anio_extracto_destino" class="font-bold">Año</label>
              <input id="anio_extracto_destino" type="number" v-model="addingYear">

              <label for="mes_extracto_destino" class="font-bold">Mes</label>
              <select id="mes_extracto_destino" v-model="addingMonth">
                <option value="" selected>Seleccione un mes...</option>
                <option v-for="(nameMonth, key, index) in monthNames" :value="parseInt(key)+1" :key="'C'+index">
                  {{ nameMonth }}
                </option>
              </select>

              <label for="valor_extracto_destino" class="font-bold">Valor</label>
              <input id="valor_extracto_destino" type="text" v-model="addingValue" @blur="formatValue">

              <button class="bg-blue-600 px-5 text-white" @click="addAdding()">
                <span>Agregar </span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 inline">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
              </button>
            </div>
            <div class="flex flex-col">
              <div class="flex flex-row">
                <div class="bg-gray-300 text-center font-bold border border-black w-1/4">AÑO</div>
                <div class="bg-gray-300 text-center font-bold border border-black w-1/4">MES</div>
                <div class="bg-gray-300 text-center font-bold border border-black w-1/4">VALOR</div>
                <div class="bg-gray-300 text-center font-bold border border-black w-1/12">&nbsp;</div>
              </div>
              <div v-for="(temporalAdding, index) of temporalAddings" :key="index" class="flex flex-row">
                <div class="bg-gray-200 text-center border border-black w-1/4">{{ temporalAdding.year }}</div>
                <div class="bg-gray-200 text-center border border-black w-1/4">{{ getCurrentMonth(temporalAdding.month) }}</div>
                <div class="bg-gray-200 text-center border border-black w-1/4">{{ vueNumberFormat(temporalAdding.value, {}) }}</div>
                <div class="bg-gray-200 text-center border border-black w-1/12">
                  <button @click="temporalAddings = temporalAddings.filter((existingTemporalAdding) => !(existingTemporalAdding.year == temporalAdding.year && existingTemporalAdding.month == temporalAdding.month))"
                          class="items-center px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-lg" v-if="isInputInvalid">
            <p class="text-left font-bold uppercase text-red-600">Los datos ingresados no son validos</p>
          </div>
          <div class="mt-4 text-lg">
            <p class="text-left font-bold">Nota:</p>
            <p class="text-left font-bold"><b>-</b> Los valores de los recuadros
              <span style="color:red;"><b>ROJOS</b></span> son editables.
            </p>
            <p class="text-left font-bold"><b>-</b> Los números con decimales deben ir separados por un punto.</p>
          </div>
        </div>
        <!-- MOVIMIENTOS-->
        <div class="relative overflow-x-auto shadow-md mt-4" style="max-height: 80vh;">
          <table class="w-full border border-black text-sm text-left text-gray-500 dark:text-gray-400"
                 style="min-width: 1400px;">
                 <th colspan="6" class="bg-[#D1D5DB] text-black p-5 text-center border border-black border-r-4">
                    RENDIMIENTOS PAGADOS
                 </th>    
                 <th colspan="6" class="bg-[#D1D5DB] text-black p-5 text-center border border-black border-l-4">
                    RENDIMIENTOS QUE DEBERIAN HABER PAGADO
                 </th>
            <tbody>
            <tr v-for="(row, index) of infoMes" :key="'F'+index"
                class="border-b border-black">
              <template v-if="index>3&&index<infoMes.length-(7 + 2 + informacionCalculoMovimientos.abonosMesesAnterioresRecibidos.length)">
                <template v-for="(col, index) of row" :key="'G'+index">
                  <template v-if="col">
                    <th scope="row"
                        :class="'py-4 font-medium text-black calculate-extract-col-width-fixed '+(col['classContainer']?col['classContainer']:'')+' '+(col['isInput']?'p-2':'px-6 py-4')"
                        v-if="index===0">
                      <input v-if="col['isInput']"
                             :class="' '+(col['classText']?col['classText']:'')"
                             @keyup="updateValues($event, year, mes)" :id="col['idInput']"
                             type="text"/>
                      <span v-else v-text="col['value']" :class="col['classText']?col['classText']:''"
                            :id="col['idInput']?col['idInput']:''"></span>
                    </th>
                    <template v-else>
                      <td :class="'border border-black text-black calculate-extract-col-width-fixed '+(col['classContainer']?col['classContainer']:'')+' '+(col['isInput']?'p-2':'px-6 py-4')">
                        <input v-if="col['isInput']"
                               :class="'width-fill-available '+(col['classText']?col['classText']:'')"
                               @keyup="updateValues($event, year, mes)" :id="col['idInput']"
                               type="text"/>
                        <span v-else v-text="col['value']" :class="col['classText']?col['classText']:''"
                              :id="col['idInput']?col['idInput']:''"></span>
                      </td>
                    </template>
                  </template>
                </template>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
    </template>
    <div class="mt-4 text-center">
      <div class="mb-3 md:flex md:flex-wrap md:justify-center md:align-middle md:gap-3">
        <button type="button" @click="generateExcel()"
                :disabled="isInputInvalid"
                :class='(isInputInvalid?"bg-gray-700 hover:bg-gray-800 ":"bg-green-700 hover:bg-green-800 ")+"w-full md:w-1/3 mb-3 md:m-0 text-white focus:outline-none focus:ring-4 focus:ring-green-300 font-medium text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"'>
          Guardar cambios y descargar informe
        </button>
        <button type="button" @click="generateExcel(false, true)"
                :disabled="isInputInvalid"
                :class='(isInputInvalid?"bg-gray-700 hover:bg-gray-800 ":"bg-yellow-500 hover:bg-yellow-800 ")+"w-full md:w-1/3 text-white focus:outline-none focus:ring-4 focus:ring-green-300 font-medium text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"'>
          Solo guardar cambios
        </button>
      </div>
      <button type="button" @click="generateExcel(true)"
              :disabled="isInputInvalid"
              :class='(isInputInvalid?"bg-gray-700 hover:bg-gray-800 ":"bg-yellow-500 hover:bg-yellow-800 ")+"md:w-1/3 text-white focus:outline-none focus:ring-4 focus:ring-green-300 font-medium text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800 w-full"'>
        Solo descargar informe
      </button>
    </div>
  </div>
</template>

<script>
import {
  copiaProfunda,
  firstLetterCapitalize,
  generateTextError,
  useAPIRest,
  verifyHttpCode,
} from "@/common/constants/functions";
import {write, writeFile} from "xlsx-js-style";
import {useAuth} from "@/components/auth/store/composables";
import {swal} from "@/common/constants/variables";
import { onUpdated, ref, watch} from "vue";
import {calculateExtract} from "@/common/constants/calculate_extract";
import {findEA} from "@/common/constants/calculate_extract/calculate_extract";
import {getCurrentMonth} from "@/common/constants/functions";
import {monthNames} from "@/common/constants";
import {utils} from "xlsx-js-style";

export default {
  name: 'CalcularExtractos',
  props: ['informacionCalculoMovimientos', 'listarInformacionRendimientos', 'vista', 'listIngresos', 'listEgresos', 'selectedYear', 'selectedMonth'],
  emits: ["updateValues"],
  data: function () {
    return {
      firstLetterCapitalize: firstLetterCapitalize,
      isInputInvalid: false
    }
  },
  setup(props, {emit}) {
    /**
     * Valor de autenticación almacenado.
     * @type {Object}
     */
    const authStored = useAuth();
    const resultFiles = ref([]);
    const resultCalculation = ref([]);
    const dataExtracto = ref({});
    const extractoId = ref(''); 
    const authToken = ref(authStored.authToken);
    const addingYear = ref(undefined)
    const addingMonth = ref(undefined)
    const addingValue = ref(undefined)
    const temporalAddings = ref([])

    function formatValue() {
      if (parseFloat(addingValue.value) < 0) {
        swal.fire('Porfavor ingrese únicamente valores mayores a 0.', '', 'error');
        addingValue.value = '';
        return;
      }

      const puntos = addingValue.value.match(/\./g);
      if(puntos && puntos.length > 1) {
        swal.fire(`Por favor, ingrese un valor numérico válido. <br> Asegúrese de utilizar solo un punto decimal y separe los miles con comas. <br> Ejemplo: 1,234.56.`, '', 'error');
        addingValue.value = '';
        return;
      } 

      if (/[a-zA-Z]/.test(addingValue.value)) {
        swal.fire('Porfavor ingrese únicamente números en el campo Valor.', '', 'error');
        addingValue.value = '';
        return;
      }
      if (addingValue.value && !isNaN(addingValue.value)) {
        const numericValue = parseFloat(addingValue.value).toFixed(2);
        const formattedValue =  numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        addingValue.value = formattedValue;
      } 
      
    }

    const reloadInformacionCalculoMovimientos = (informacionCalculoMovimientosNew) => {
      const {extracto_id} = informacionCalculoMovimientosNew;
      extractoId.value = extracto_id;
      const {
        filesInfo,
        data,
        newDataExtracto
      } = calculateExtract(copiaProfunda(informacionCalculoMovimientosNew));
      temporalAddings.value = informacionCalculoMovimientosNew.abonosMesesAnterioresDados
      resultFiles.value = filesInfo;
      resultCalculation.value = data;
      dataExtracto.value = newDataExtracto;
    }

    reloadInformacionCalculoMovimientos(props.informacionCalculoMovimientos);
    /**
     * Observador que se ejecuta cuando cambia la información de cálculo de movimientos.
     * @function
     * @name watchInformacionCalculoMovimientos
     * @param {Object} informacionCalculoMovimientos - Información de cálculo de movimientos.
     */
    watch(() => props.informacionCalculoMovimientos, (informacionCalculoMovimientos) => {
      reloadInformacionCalculoMovimientos(informacionCalculoMovimientos);
    });
    /**
     * Hook que se ejecuta después de cada actualización del componente.
     * @function
     * @name onComponentUpdate
     */
    onUpdated(() => {
      if (document.getElementById('tasaEA')) {
        for (const year in props.informacionCalculoMovimientos) {
          if (!isNaN(parseInt(year))) for (const mes in props.informacionCalculoMovimientos[year]) {
            document.getElementById('tasaEA').value = props.informacionCalculoMovimientos[year][mes]['tasa_e_a_entidad'];
            document.getElementById('rendimientosPeriodoIzq').value = props.informacionCalculoMovimientos[year][mes]['rendimiento_periodo'];
            document.getElementById('gananciaInteresesAdicionales').value = props.informacionCalculoMovimientos[year][mes]['ganancia_interes_adicional'];
            document.getElementById('rendimientosPeriodoPagadosMesSiguiente').value = props.informacionCalculoMovimientos[year][mes]['rendimiento_periodo_pagado_mes_siguiente'];
          }
        }
      }
    });
    return {
      resultFiles,
      resultCalculation,
      dataExtracto,
      extractoId,
      authToken,
      monthNames,
      addingYear,
      addingMonth,
      addingValue,
      temporalAddings,
      getCurrentMonth,
      emit,
      formatValue
    }
  },
  methods: {
    /**
     * Genera y carga en el servidor un archivo Excel con información de rendimientos.
     *
     * @async
     * @param {boolean} [onlyDownloadReport=false] - Indica si se debe descargar solamente el reporte.
     * @param {boolean} [onlyLoadChanges=false] - Indica si se deben cargar solo los cambios.
     * @returns {Promise<void>}
     */
    async generateExcel(onlyDownloadReport = false, onlyLoadChanges = false) {
      for (const fileInfo of this.resultFiles) {
        const [workbook, fileName, infoFile, year, meses] = fileInfo;
        const generateBorder = (width, color) => {
          const borderObject = {};
          for (const side of ['left', 'right', 'bottom', 'top']) {
              borderObject[side] = {
                  style: width,
                  color: {
                      rgb: color
                  }
              };
          }
          return borderObject;
        };
        let filas = 0
        Object.keys(workbook.Sheets[Object.keys(workbook.Sheets)[0]]).forEach(element => {if (element.startsWith('A')) filas++;})
        utils.sheet_add_aoa(workbook.Sheets[Object.keys(workbook.Sheets)[0]], [['', 'ABONOS', '']], {origin: 'I' + (filas - 4)});
        let abonos = this.informacionCalculoMovimientos.abonosMesesAnterioresRecibidos.map((abono) => ({AÑO: abono.year, MES: getCurrentMonth(abono.month), VALOR: abono.value}))
        utils.sheet_add_json(workbook.Sheets[Object.keys(workbook.Sheets)[0]], abonos, {origin: 'I' + (filas - 3)});
        workbook.Sheets[Object.keys(workbook.Sheets)[0]]['I' + (filas - 4)]['s'] = {
          fill: {
              fgColor: {
                  rgb: "FFC000"
              }
          },
        }
        workbook.Sheets[Object.keys(workbook.Sheets)[0]]['J' + (filas - 4)]['s'] = {
          fill: {
              fgColor: {
                  rgb: "FFC000"
              }
          },
          font: {
              bold: true
          },
          alignment: {
              horizontal: 'center'
          },
        }
        workbook.Sheets[Object.keys(workbook.Sheets)[0]]['K' + (filas - 4)]['s'] = {
          fill: {
              fgColor: {
                  rgb: "FFC000"
              }
          },
        }
        let customBorder = generateBorder('medium', '000000')
        if (abonos.length) {
          workbook.Sheets[Object.keys(workbook.Sheets)[0]]['I' + (filas - 3)]['s'] = {
              alignment: {
                  horizontal: 'center'
              },
              font: {
                  bold: true
              },
              border: customBorder
          }
          workbook.Sheets[Object.keys(workbook.Sheets)[0]]['J' + (filas - 3)]['s'] = {
              alignment: {
                  horizontal: 'center'
              },
              font: {
                  bold: true
              },
              border: customBorder
          }
          workbook.Sheets[Object.keys(workbook.Sheets)[0]]['K' + (filas - 3)]['s'] = {
              alignment: {
                  horizontal: 'center'
              },
              font: {
                  bold: true
              },
              border: customBorder
          }
        }
        customBorder = generateBorder('thin', '000000')
        for (let i = 0; i < abonos.length ; i++) {
          workbook.Sheets[Object.keys(workbook.Sheets)[0]]['I' + (filas - (2 + i))]['s'] = {
            alignment: {
                horizontal: 'center'
            },
            border: customBorder
          }
          workbook.Sheets[Object.keys(workbook.Sheets)[0]]['J' + (filas - (2 + i))]['s'] = {
            alignment: {
                horizontal: 'center'
            },
            border: customBorder
          }
          workbook.Sheets[Object.keys(workbook.Sheets)[0]]['K' + (filas - (2 + i))]['s'] = {
            alignment: {
                horizontal: 'center'
            },
            border: customBorder
          }
        }

        let isProcessSuccess = false;
        let messageInfo = '';
        try {
          if (!onlyLoadChanges) writeFile(workbook, fileName, infoFile);
          else write(workbook, infoFile);
          isProcessSuccess = true;
        } catch (error) {
          console.error(error);
          await swal.fire('Error inesperado. Informar al administrador.', '', 'error');
        }
        if (isProcessSuccess) {
          if (onlyDownloadReport) messageInfo += '<b>Generación del informe: ¡Exitoso!</b><div></div>';
          else {
            await this.saveAddings()
            isProcessSuccess = false;
            messageInfo += '<b>1. Generación del informe: ¡Exitoso!</b><div></div>';
            /**
             * Carga el archivo Excel en el servidor y vincula el informe con el extracto bancario.
             *
             * @async
             * @param {Object} fileInfo - Objeto con la información del archivo Excel.
             * @param {string} fileInfo.fileName - Nombre del archivo Excel.
             * @param {string} fileInfo.year - Año de los rendimientos.
             * @param {Array} fileInfo.meses - Meses de los rendimientos.
             * @returns {Promise<void>}
             */
            await useAPIRest(process.env.VUE_APP_NEST_INFORMACIONRENDIMIENTOS_SUBIRINFORME, 'POST', this.authToken, fileInfo).then(async resJSON => {
              const {statusCode} = resJSON;
              delete resJSON.statusCode;
              const textoError = generateTextError(resJSON);
              if (verifyHttpCode(statusCode, 'success')) {
                messageInfo += '<b>2. Cargue del informe en el servidor: ¡Exitoso!</b><div></div>';
                /**
                 * Actualiza la información del extracto bancario con la información de los rendimientos.
                 * @async
                 * @param {Object} resJSON - Objeto con la información de los rendimientos.
                 * @param {string} resJSON.url_informe - URL del archivo Excel de los rendimientos.
                 * @param {number} resJSON.rendimiento_periodo - Rendimiento del período.
                 * @param {number} resJSON.ganancia_interes_adicional - Ganancia por intereses adicionales.
                 * @param {number} resJSON.rendimiento_periodo_pagado_mes_siguiente - Rendimiento del período pagado el mes siguiente.
                 * @param {number} resJSON.interes_tasa_pactada - Tasa de interés pactada.
                 * @param {number} resJSON.tasa_efectiva_anual_real_pagada - Tasa efectiva anual real pagada.
                 * @returns {Promise<void>}
                 */
                await useAPIRest(process.env.VUE_APP_NEST_EXTRACTOBANCARIO_FINDONE.replace(':id', this.extractoId), 'GET', this.authToken).then(async resJSON => {
                  const {statusCode} = resJSON;
                  delete resJSON.statusCode;
                  const textoError = generateTextError(resJSON);
                  if (verifyHttpCode(statusCode, 'success')) {
                    const dataExtractoByYearMonth = this.dataExtracto[year][meses[0]];
                    resJSON.url_informe = `src/assets/informes_rendimientos/${fileName}`;
                    resJSON.rendimiento_periodo = dataExtractoByYearMonth.rendimiento_periodo;
                    resJSON.ganancia_interes_adicional = dataExtractoByYearMonth.ganancia_interes_adicional;
                    resJSON.rendimiento_periodo_pagado_mes_siguiente = dataExtractoByYearMonth.rendimiento_periodo_pagado_mes_siguiente;
                    resJSON.interes_tasa_pactada = dataExtractoByYearMonth.interes_tasa_pactada;
                    resJSON.tasa_efectiva_anual_real_pagada = parseFloat(dataExtractoByYearMonth.tasa_efectiva_anual_real_pagada);
                    delete resJSON.created_at;
                    delete resJSON.id;
                    delete resJSON['updated_at'];
                    delete resJSON.bancoTasaEfectivaAnual
                    await useAPIRest(process.env.VUE_APP_NEST_EXTRACTOBANCARIO_UPDATE.replace(':id', this.extractoId), 'PATCH', this.authToken, resJSON).then(resJSON => {
                      const {statusCode} = resJSON;
                      delete resJSON.statusCode;
                      const textoError = generateTextError(resJSON);
                      if (verifyHttpCode(statusCode, 'success')) {
                        messageInfo += '<b>3. Vinculación del informe con el extracto: ¡Exitoso!</b><div></div>';
                        isProcessSuccess = true;
                        if (this.listarInformacionRendimientos) this.listarInformacionRendimientos(this.authToken);
                      } else {
                        messageInfo += '<b>3. Vinculación del informe con el extracto: ¡Fallido!</b>';
                        messageInfo += `<div class="px-10 text-left"><b>Detalles:</b><div class="px-5"><small>${textoError}</small></div></div>`
                        // swal.fire(textoError, '', 'error');
                      }
                    });
                  } else {
                    messageInfo += '<b>3. Vinculación del informe con el extracto: ¡Fallido!</b><div></div>';
                    await swal.fire(textoError, '', 'error');
                  }
                });
              } else {
                messageInfo += '<b>2. Cargue del informe en el servidor: ¡Fallido!</b><div></div>';
                await swal.fire(textoError, '', 'error');
              }
            });
          }
          await swal.fire('Estado del informe', messageInfo, isProcessSuccess ? 'success' : 'error');
          if (!isProcessSuccess) break;
        }
      }
    },

    /**
     * Calcula la tasa de interés efectiva anual (Tasa EA) para un mes y año específico.
     *
     * @method
     * @name calculateEA
     * @param {number} year - El año para el que se desea calcular la Tasa EA.
     * @param {number} mes - El mes para el que se desea calcular la Tasa EA (1 = enero, 2 = febrero, etc.).
     * @return {void}
     * @memberof VueComponent
     */
    calculateEA(year, mes) {
      let informacionCalculoMovimientos = copiaProfunda(this.informacionCalculoMovimientos);
      const rendimientoPeriodo = informacionCalculoMovimientos[year][mes]['rendimiento_periodo'];
      const gananciaInteresAdicional = informacionCalculoMovimientos[year][mes]['ganancia_interes_adicional'];
      const rendimientoPeriodoPagadoMesSiguiente = informacionCalculoMovimientos[year][mes]['rendimiento_periodo_pagado_mes_siguiente'];
      informacionCalculoMovimientos[year][mes]['tasa_e_a_entidad'] = (findEA({
        listIngresos: this.listIngresos,
        listEgresos: this.listEgresos,
        interesesRealesPagados: Number(rendimientoPeriodo) + Number(gananciaInteresAdicional) + Number(rendimientoPeriodoPagadoMesSiguiente)
      }) * 100).toFixed(10);
      this.$emit('updateValues', {'informacionCalculoMovimientos': informacionCalculoMovimientos});
    },
    /**
     * Actualiza los valores dinámicos de un mes y año específico y emite un evento para informar a los componentes padres.
     *
     * @method
     * @name updateValues
     * @param {object} $event - El objeto evento que se ha desencadenado.
     * @param {number} year - El año para el que se desea actualizar los valores.
     * @param {number} mes - El mes para el que se desea actualizar los valores (1 = enero, 2 = febrero, etc.).
     * @return {void}
     * @memberof VueComponent
     */
    updateValues($event, year, mes) {
      // Valores dinámicos
      let tasaEA = document.getElementById('tasaEA').value;
      tasaEA = tasaEA ? tasaEA : '';
      let rendimientosPeriodoIzq = document.getElementById('rendimientosPeriodoIzq').value;
      rendimientosPeriodoIzq = rendimientosPeriodoIzq ? rendimientosPeriodoIzq : '';
      let gananciaInteresesAdicionales = document.getElementById('gananciaInteresesAdicionales').value;
      gananciaInteresesAdicionales = gananciaInteresesAdicionales ? gananciaInteresesAdicionales : '';
      let rendimientosPeriodoPagadosMesSiguiente = document.getElementById('rendimientosPeriodoPagadosMesSiguiente').value;
      rendimientosPeriodoPagadosMesSiguiente = rendimientosPeriodoPagadosMesSiguiente ? rendimientosPeriodoPagadosMesSiguiente : '';
      let informacionCalculoMovimientos = copiaProfunda(this.informacionCalculoMovimientos);
      // Actualizar valores dinámicos
      informacionCalculoMovimientos[year][mes]['tasa_e_a_entidad'] = tasaEA;
      informacionCalculoMovimientos[year][mes]['rendimiento_periodo'] = rendimientosPeriodoIzq;
      informacionCalculoMovimientos[year][mes]['ganancia_interes_adicional'] = gananciaInteresesAdicionales;
      informacionCalculoMovimientos[year][mes]['rendimiento_periodo_pagado_mes_siguiente'] = rendimientosPeriodoPagadosMesSiguiente;
      this.isInputInvalid = Boolean([tasaEA, rendimientosPeriodoIzq, gananciaInteresesAdicionales].filter(value => isNaN(value)).length);
      this.$emit('updateValues', {'informacionCalculoMovimientos': informacionCalculoMovimientos});
    },

    async addAdding() {
      this.addingValue = this.addingValue.replace(',','');
      if(this.addingYear && this.addingMonth && this.addingValue && this.addingValue > 0) {
        const resJSON = await useAPIRest(process.env.VUE_APP_NEST_ABONOMESANTERIOR_VALIDATEPOSSIBLEADDING.replace(':extracto_origen_id', this.extractoId).replace(':anio', this.addingYear).replace(':mes', this.addingMonth).replace(':valor', this.addingValue), 'GET', this.authToken)
        const {statusCode} = resJSON
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) {
          if (this.temporalAddings.every((temporalAdding) => temporalAdding.year !== this.addingYear || temporalAdding.month !== this.addingMonth)) {
            if (this.temporalAddings.map((temporalAdding) => temporalAdding.value).reduce((accumulator, currentValue) => accumulator + currentValue, 0) + this.addingValue < parseFloat(this.resultCalculation[this.selectedYear][this.selectedMonth][this.resultCalculation[this.selectedYear][this.selectedMonth].length - 5][1].value.replace(/,/g, ''))) {
              this.temporalAddings.push({year: this.addingYear, month: this.addingMonth, value: this.addingValue})
              this.addingYear = undefined
              this.addingMonth = undefined
              this.addingValue = undefined
            }
            else {
              await swal.fire('El valor de los abonos supera los rendimientos recibidos por este extracto', '', 'error');
            }
          }
          else {
            await swal.fire('Ya está intentando agregar un abono en el mismo año y mes', '', 'error');
          }
        }
        else {
          await swal.fire(textoError, '', 'error');
        }
      }
    },

    async saveAddings() {
      await useAPIRest(process.env.VUE_APP_NEST_ABONOMESANTERIOR_CREATE.replace(':extracto_origen_id', this.extractoId), 'POST', this.authToken, this.temporalAddings)
    }
  }
}
</script>